
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'ExpandAllIcon',
})
export default class ExpandAllIcon extends Vue {
  @Prop({ required: true }) private expanded!: boolean;
}
